import { styled } from '@mui/material/styles';

export const Form = styled('form')(() => ({
  width: '100%',
  margin: '32px 0',
  maxWidth: '1280px',
}));
